const state = () => ({
	inputDialog: new Object(),
	roleForm: {
		rolename: '',
		main: 1,
		sex: 0,
		icon: 0,
		id: 0
	},
	roles: {
		rolename: [{
				required: true,
				message: "Enter the role's name",
				trigger: 'blur'
			},
			{
				min: 3,
				max: 20,
				message: 'Please enter at least three characters.',
				trigger: 'blur'
			}
		],
	},
	newRoleList: []
})

// getters
const getters = {
	
}

// actions
const actions = {
	
}

// mutations
const mutations = {
	initInputDefaultDialog(state, dialog) {
		state.inputDialog = dialog
	},
	checkoutRoleFn(state, item) {
		state.inputDialog.main = item.main
		state.inputDialog.role = item.id
		state.inputDialog.rolename = item.rolename
		state.inputDialog.roleImage = item.icon
		state.inputDialog.roleSex = item.sex
	},
	checkRoleFn(state, {role, sex}) {
		state.roleForm.icon = role
		state.roleForm.sex = sex
	},
	resetRoleListFn(state) {
		state.newRoleList = [] // 重置 role list 恢复初始化数据
		if (JSON.parse(localStorage.role_list).length > 0) {
			let role_list = JSON.parse(localStorage.getItem('role_list'))
			function compare(main){
			     return function(a,b){
			         var value1 = a[main];
			         var value2 = b[main];
			         return value2 - value1;
			     }
			}
			role_list.sort(compare('main'))
			role_list.unshift(...role_list.splice(role_list.findIndex(i => i.id === 0), 1))
			role_list.forEach((item,index) => {
				if (item.icon < 10 && item.icon > 0) {
					item.icon = `0${item.icon}`
				} 
			})
			state.newRoleList = role_list	
		} 
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}